import { customComponents as ShellCustomComponents } from '../../custom-components'

export const shellComponents = ShellCustomComponents
